import { render } from "./ActivationModal.vue?vue&type=template&id=5d7a978e"
import script from "./ActivationModal.vue?vue&type=script&lang=js"
export * from "./ActivationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__